/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Direct_OpgeslagenInputs */

const nl_planning_rooster_direct_opgeslagen = /** @type {(inputs: Planning_Rooster_Direct_OpgeslagenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen worden direct opgeslagen.`)
};

/**

* @param {Planning_Rooster_Direct_OpgeslagenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_direct_opgeslagen = /** @type {((inputs?: Planning_Rooster_Direct_OpgeslagenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Direct_OpgeslagenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_direct_opgeslagen(inputs)
});
export { planning_rooster_direct_opgeslagen as "planning.rooster.direct_opgeslagen" }